import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslocoModule } from '@ngneat/transloco';

import { CtdUnpaidModalComponent } from './ctd-unpaid-modal.component';
import { CtdUnpaidModalService } from 'src/app/modals/pos-manager/ctd-unpaid-modal/ctd-unpaid-modal.service';

@NgModule({
  declarations: [CtdUnpaidModalComponent],
  imports: [CommonModule, IonicModule, FontAwesomeModule, TranslocoModule],
  providers: [CtdUnpaidModalService]
})
export class CtdUnpaidModalComponentModule {}
